import script from "./LinkingInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkingInput.vue?vue&type=script&lang=ts&setup=true"

import "./LinkingInput.vue?vue&type=style&index=0&id=0320cbdb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0320cbdb"]])

export default __exports__